import {createSelector} from 'reselect';

const getShoppingCart = (store) => store.shoppingCart.shoppingCart || {};
const getUser = (store) => store.user || {};
const getTravellers = (shoppingCart) => shoppingCart.travellers;
const getBuyer = (shoppingCart) => shoppingCart.buyerDTO;
const getBookingId = (shoppingCart) => shoppingCart.bookingId;
const getRequiredTravellerInformation = (shoppingCart) => shoppingCart.requiredTravellerInformation || [];
const frequentFlyerShowed = (shoppingCart) => {
    const requiredTravellerInfo = getRequiredTravellerInformation(shoppingCart);
    const hasMeals = (requiredTravellerInfo) => requiredTravellerInfo.availableMeals.length > 0;
    const validFrequentFlyer = (requiredTravellerInfo) =>
        requiredTravellerInfo.travellerType === 'ADULT' && requiredTravellerInfo.frequentFlyerAirlineGroups.length > 0;
    const showSection = (requiredTravellerInfo) => hasMeals(requiredTravellerInfo) || validFrequentFlyer(requiredTravellerInfo);
    return requiredTravellerInfo && requiredTravellerInfo.some(showSection);
};

const getNumPassengers = (shoppingCart) => {
    const requiredTravellerInfo = getRequiredTravellerInformation(shoppingCart);
    return requiredTravellerInfo.length || 1;
};

const getNumPassengersWithoutInfants = (shoppingCart) => {
    const requiredTravellerInfo = getRequiredTravellerInformation(shoppingCart);
    return requiredTravellerInfo.filter(({travellerType} = {}) => travellerType !== 'INFANT').length || 1;
};

const getPaxTypes = (shoppingCart) => {
    const requiredTravellerInfo = getRequiredTravellerInformation(shoppingCart) || [];
    return requiredTravellerInfo.reduce(
        (acc, current) => {
            const type = current.travellerType;
            const numberType = acc[`num${type}`];
            return Object.assign({}, acc, {[`num${type}`]: numberType + 1});
        },
        {
            numADULT: 0,
            numCHILD: 0,
            numINFANT: 0,
        }
    );
};
const isPrimeMember = (membershipDTO, traveller) => {
    let primeName = membershipDTO.name + (membershipDTO.lastNames || '');
    let travellerName = traveller.name + (traveller.firstLastName || '') + (traveller.secondLastName || '');
    travellerName = travellerName.replace(/\s+/g, '');
    primeName = primeName.replace(/\s+/g, '');

    return travellerName === primeName;
};
const shoppingCartTravellersSelector = createSelector(getShoppingCart, getTravellers);
const requiredTravellerInfoSelector = createSelector(getShoppingCart, getRequiredTravellerInformation);
const buyerSelector = createSelector(getShoppingCart, getBuyer);
const bookingIdSelector = createSelector(getShoppingCart, getBookingId);
const frequentFlyerShowedSelector = createSelector(getShoppingCart, frequentFlyerShowed);
const numPassengersSelector = createSelector(getShoppingCart, getNumPassengers);
const paxTypesNumberSelector = createSelector(getShoppingCart, getPaxTypes);
const numPassengersWithoutInfantsSelector = createSelector(getShoppingCart, getNumPassengersWithoutInfants);
const travellersSelector = createSelector(getUser, shoppingCartTravellersSelector, (user, travellers) => {
    if (user && user.membershipDTO && travellers) {
        return travellers.map((traveller) => {
            traveller.isPrimeMember = isPrimeMember(user.membershipDTO, traveller);
            return traveller;
        });
    }
    return travellers;
});

export default {
    buyer: (store) => buyerSelector(store),
    travellers: (store) => travellersSelector(store),
    requiredTravellerInfo: (store) => requiredTravellerInfoSelector(store),
    bookingId: (store) => bookingIdSelector(store),
    frequentFlyerShowed: (store) => frequentFlyerShowedSelector(store),
    numPassengers: (store) => numPassengersSelector(store),
    numPassengersWithoutInfants: (store) => numPassengersWithoutInfantsSelector(store),
    paxTypesNumber: (store) => paxTypesNumberSelector(store),
};
